
import { Counter } from '../components/counter';
import { References } from "../components/references";
import { Newsletter } from "../components/newsletter";
import { Partners } from "../components/partners";

function Trusted() {
  return (
    <>
      <Counter />
      <References />
      <Partners />
      <Newsletter />
    </>
  );
}

export default Trusted;